import type { TrustGroup } from "@/models/trustGroup";
import axios from "axios";
import type { AddTrustGroupUserDto } from "@/models/dto/addTrustGroupUserDto";
import type { TrustGroupDto } from "@/models/dto/trustGroupDto";

export const getTrustGroup = async (
  email: string
): Promise<TrustGroup | undefined> => {
  try {
    const response = await axios.get("/api/admin/trust-group", {
      params: {
        email,
      },
    });
    return response.data;
  } catch (error) {
    return undefined;
  }
};

export const addMemberToTrustGroup = async (
  addTrustGroupUserDto: AddTrustGroupUserDto
): Promise<void> => {
  const response = await axios.put(
    "/api/admin/trust-group/add-user",
    addTrustGroupUserDto
  );
  return response.data;
};

export const removeMemberFromTrustGroup = async (
  addTrustGroupUserDto: AddTrustGroupUserDto
): Promise<void> => {
  const response = await axios.put(
    "/api/admin/trust-group/remove-user",
    addTrustGroupUserDto
  );
  return response.data;
};

export const createTrustGroup = async (
  trustGroupDto: TrustGroupDto
): Promise<void> => {
  const response = await axios.post("/api/admin/trust-group", trustGroupDto
  );
  return response.data;
};
